import { createContext } from 'react';

// The analyst's "this session is the attacker's" control (utils/sessionMarks.js, v1.190.0),
// provided once by CaseDetail so every session-id display can offer it without threading a
// setter through each view. `onSet(sessionId, reason | null)` returns a promise; null removes.
export const SessionMarkContext = createContext({ onSet: null });
